import { render, staticRenderFns } from "./CompanyNewModal.vue?vue&type=template&id=259e6625"
import script from "./CompanyNewModal.vue?vue&type=script&lang=js"
export * from "./CompanyNewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports